(function() {
  function llooniInit(sectionId) {
    function llooniBuildCartRow() {
      var qtyWrap = document.getElementById('Quantity-Form-' + sectionId);
      var productFormEl = document.querySelector('product-form[data-section-id="' + sectionId + '"]');
      var outerWrap = productFormEl ? productFormEl.parentElement : null;
      if (!qtyWrap || !outerWrap || qtyWrap.closest('.llooni-cart-row')) return;
      var row = document.createElement('div');
      row.className = 'llooni-cart-row';
      outerWrap.parentNode.insertBefore(row, outerWrap);
      row.appendChild(qtyWrap);
      row.appendChild(outerWrap);
    }

    function llooniUpdateCartButton() {
      var btn = document.getElementById('ProductSubmitButton-' + sectionId);
      var btnSpan = btn ? btn.querySelector('span') : null;
      var priceContainer = document.getElementById('price-' + sectionId);
      var qtyInput = document.querySelector('#Quantity-Form-' + sectionId + ' input[name="quantity"]');
      if (!btnSpan || !priceContainer || !qtyInput) return;
      var priceEl = priceContainer.querySelector('.price-item--regular') || priceContainer.querySelector('.price-item');
      if (!priceEl) return;
      var raw = priceEl.textContent.trim().replace(/[^0-9,]/g, '').replace(',', '.');
      var unit = parseFloat(raw);
      var qty = parseInt(qtyInput.value, 10) || 1;
      if (isNaN(unit)) return;
      var total = (unit * qty).toFixed(2).replace('.', ',');
      btnSpan.innerHTML = 'Ajouter <span class="llooni-btn-optional">au panier </span>– ' + total + ' €';
    }

    llooniBuildCartRow();
    llooniUpdateCartButton();
    document.addEventListener('change', llooniUpdateCartButton);
    document.addEventListener('input', llooniUpdateCartButton);
    var priceContainer = document.getElementById('price-' + sectionId);
    if (priceContainer) {
      new MutationObserver(llooniUpdateCartButton).observe(priceContainer, { childList: true, subtree: true, characterData: true });
    }
  }

  document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('[data-llooni-cart-row-section]').forEach(function(el) {
      llooniInit(el.getAttribute('data-llooni-cart-row-section'));
    });
  });
})();
